import styled from '@emotion/styled';

export const FormLabel = styled.label`
  margin: 0;
  margin-bottom: 4px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
`;
